<div [ngSwitch]="displayStyle" class="category-filters">

  <div *ngSwitchCase="'dropdown'" class="category-filters-dropdown">
    <mat-form-field>
      <mat-select
        placeholder="{{ 'ExerciceCategories' | translate }}"
        [value]="selectedCategoryIds"
        (selectionChange)="onSelectChange($event.value)"
        multiple
      >
        <mat-option *ngFor="let category of categories" [value]="category.id">
          <exercice-category-thumbnail [hideText]="true" [data]="category" /> {{ category.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngSwitchCase="'list'"  class="category-filters-list">
    <exercice-category-filters-item
      [category]="allCategoriesItem"
      [selected]="selectedCategoryIds.length === 0"
      (click)="onCategoryClick(allCategoriesItem.id)"
    >
    </exercice-category-filters-item>
    <ng-container *ngFor="let category of categories">
      <exercice-category-filters-item
        [category]="category"
        [selected]="selectedCategoryIds.includes(category.id!)"
        (click)="onCategoryClick(category.id)"
      >
      </exercice-category-filters-item>
    </ng-container>
  </div>
</div>
